/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "2lleGP6mYHs",
    title: "Top 10 Portrait Tips and Tricks to Become a Better Photographer",
    description:
      "Tips and tricks one should follow to become better at portrait photography.",
    creator: "Irene Rudnyk",
    views:'579K',
    duration:'10:01',
    categoryName:'Portrait Photography',
    published:'1 year'
  },
  {
    _id: "kCu_JaxaxX0",
    title: "5 Basics of Architecture Photography - Tips & Tricks",
    description:"If you're new to architecture, interiors, and real estate photography then this video is for you",
    creator: "Mathew Anderson",
    views:'4.3K',
    duration:'12:17',
    categoryName:'Architectural Photography',
    published:'7months'
  },
  {
    _id:"N2bhaD9tiWI",
    title:'14 SIMPLE Photography Tips for BREATHTAKING portraits',
    description:`Here are 14 simple photography tricks and tips to take amazing 
    portrait photography! With these photography tips for beginners, you can learn how
     to take portraits and improve your portrait photography fast.`,
    creator:'Bach Photography',
    views:'735K',
    duration:'10:01',
    categoryName:'Portrait Photography',
    published:'2 years'
  },
  {
    _id: "Y-LvHkDDWO8",
    title: "The Fundamentals of Fashion Photography with Shavonne Wong",
    description:
      "Know fundamentals of fashion photography before you start with it.",
    creator: "Fstoppers",
    views:'100K',
    duration:'5:52',
    categoryName:'Fashion Photography',
    published:'1 year'
  },
  {
    _id: "V7z7BAZdt2M",
    title: "PHOTOGRAPHY BASICS in 10 MINUTES",
    description: "Basics about photography one must know before starting with photography.",
    creator: "David Manning",
    views:'4.5M',
    duration:'11:09',
    categoryName:'Portrait Photography',
    published:'3 years'
  },
  {
    _id: "YDL-sNZk84c",
    title: "The Art of Architectural Photography With Ema Peter",
    description:"Ema Peter, a Vancouver-based photographer, captures some of the most beautiful works of architecture in Canada and around the world",
    creator: "NUVO Magazine",
    views:'12K',
    duration:'4:35',
    categoryName:'Architectural Photography',
    published:'9months'
  },
  {
    _id: "Ci8imO2jtDk",
    title: "How I Edit Natural Light Portraits in Photoshop",
    description: "Editing tips for portraits",
    creator: "Irene Rudnyk",
    views:'601K',
    duration:'25:59',
    categoryName:'Portrait Photography',
    published:'5 years'
  },
  {
    _id: "LUpgF2G32Qs",
    title: "8 Tips for Succeeding as a Fashion Photographer",
    description:"How can you work your way up the fashion photography ladder and what do you need to succeed?",
    creator: "Karl Taylor",
    views:'86K',
    duration:'16:33',
    categoryName:'Fashion Photography',
    published:'1 year'
  },
  {
    _id: "yiblDn4JGfQ",
    title: "How to photograph INCREDIBLE ARCHITECTURE!",
    description:"Tips to improve your architectural photography.",
    creator: "Peter McKinnon",
    views:'666K',
    duration:'4:11',
    categoryName:'Architectural Photography',
    published:'4 years'
  },
  {
    _id: "4FE_AUhtRb8",
    title: "Fashion Photography: How to make a catalogue photoshoot (BTS)",
    description:"Follow me in this BTS of a catalogue photoshoot for e-commerce, where I will show you the lighting technique used.",
    creator: "Laredo Montoneri",
    views:'274K',
    duration:'8:19',
    categoryName:'Fashion Photography',
    published:'2 years'
  },
  {
    _id: "V9w5E9I5bW4",
    title: "Outdoor Portraits Essentials: Natural Light Photography, Fill Flash & Diffusers",
    description: "Learn how to take gorgeous outdoor portraits with any camera, whether you're working with a model or your family",
    creator: "Tony & Chelsea Northup",
    views:'1.3M',
    duration:'6:53',
    categoryName:'Portrait Photography',
    published:'6 years'
  },
  {
    _id: "BAiN4Wyf_KY",
    title: "Photography Tutorial | How To Take Better Portraits For Beginners",
    description: "This is a portrait photography tutorial for beginners, and will help you learn how to take beautiful natural light portraits with any camera equipment.",
    creator: "Bach Photography",
    views:'338K',
    duration:'14:41',
    categoryName:'Portrait Photography',
    published:'2 years'
  },
  {
    _id: "lCN2aU3cuwc",
    title: "5 Fashion Photography Tips with Lara Jade",
    description:"Fashion photographer Lara Jade shares her fashion photography tips.",
    creator: "B&H Photo Video",
    views:'31K',
    duration:'6:10',
    categoryName:'Fashion Photography',
    published:'1 year'
  },
  {
    _id: "OtZAku_co3w",
    title: "Architecture Photography Tips",
    description:"Tips to improve your architectural photography. You'll learn the stylistic and technical fundamentals to help you take better photographs of architecture",
    creator: "30X40 Design Workshop",
    views:'253K',
    duration:'11:22',
    categoryName:'Architectural Photography',
    published:'4 years'
  },
  {
    _id:"Um1TT_Nq9BI",
    title:'Fashion Photography Tips in Hindi | Outdoor Photoshoot India | PBVlogs',
    description:'Day in photographers life . Sharing Fashion photography tips in Hindi from outdoor designer photoshoot .',
    creator:'Praveen Bhat Photography',
    views:'4.5K',
    duration:'5:27',
    categoryName:'Fashion Photography',
    published:'1 year'
  },
  {
    _id: "i1MdxIFaxbc",
    title: "Secrets of Architecture Photography | Tobi Shinobi",
    description:"Tobi Shinobi shares his insights on architecture photography as he visits his favorite spots around Chicago.",
    creator: "Sony | Alpha Universe",
    views:'16K',
    duration:'34:46',
    categoryName:'Architectural Photography',
    published:'1 year'
  },
  {
    _id:"wmIvdzAIRMg",
    title:'Lara Jade on Fashion Photography, Her Most Memorable Photoshoot & More | 21 Questions',
    description:`Maria dropped in on fashion photographer Lara Jade while she was packing 
    for a photoshoot. They talk about self portraits, fine art and jewelry photography, 
    the magazines she’d love to work with, her favorite portrait lighting and more`,
    creator:'B&H Photo Video',
    views:'8.6K',
    duration:'8:44',
    categoryName:'Fashion Photography',
    published:'1 year'
  },
  {
    _id:"wCGMRA502qI",
    title:'7 tips for architecture photography',
    description:`The COOPH team headed out with the new Leica CL to test some useful
     hints and tips for architecture photography. In this video we try out a variety of tips and tricks 
     that are sure to perfect your architecture photography, whether you are shooting 
     from inside or out! `,
    creator:'COOPH',
    views:'105K',
    duration:'4:43',
    categoryName:'Architectural Photography',
    published:'3 years'
  }
];
